// ======================================================================
// File Name       : DownloadConfigFileContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// ======================================================================
// File Name       : DownloadConfigFileContainer
//
// Copyright(C) 2018 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Form, Col } from 'react-bootstrap';
import DownloadConfigFileList from '../../components/configFile/DownloadConfigFileList';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { RETURN_MAX_NUM } from '../../constants/index';
import * as configFileAction from '../../actions/ConfigFileAction';
import Header from '../../components/Header';
import { handleDownload } from '../../utils/index';

class DownloadConfigFileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.onDownLoadCancel = this.onDownLoadCancel.bind(this);
    this.onDownloadOk = this.onDownloadOk.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.onClickDownloadFile = this.onClickDownloadFile.bind(this);
  }

  componentWillMount() {
    this.searchData();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(configFileAction.resetDataDownloadConfigFile());
  }

  searchData(startPosition, column) {
    const { dispatch } = this.props;
    const defaultParam = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
    };
    if (startPosition) {
      defaultParam.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      defaultParam.ascendingDescendingSort = column.sortState;
      defaultParam.userfrontDownloadSortType = column.sortBy;
    }

    if (!column) {
      defaultParam.ascendingDescendingSort = null;
      defaultParam.userfrontDownloadSortType = null;
    }
    dispatch(configFileAction.getDownloadConfigFileResult(defaultParam));
  }

  onClickDownloadFile(url, fileName) {
    return handleDownload(url, fileName);
  }

  onClickDownLoad(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  onDownLoadCancel() {
    this.setState({ showModal: false });
  }

  onDownloadOk() {
    const { dispatch } = this.props;
    dispatch(configFileAction.downloadConfigFile()).then(() => {
      this.searchData();
    });
    this.setState({ showModal: false });
  }

  refreshData() {
    this.searchData();
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues && formValues.userfrontDownloadSortType) {
      column = formValues.userfrontDownloadSortType;
    }
    this.searchData(startPosition, column);
  }

  render() {
    const { downloadConfigFile, invalid, formValues } = this.props;
    const { userfrontDownloadResultList, recordNum } = downloadConfigFile;
    let startPosition = 0;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    return (
      <div>
        <Header name="画面用構成ファイルダウンロード" />
        <Form className='form-horizontal'>
          <h3>画面用構成ファイルのダウンロードを開始するには、以下のボタンを押して下さい</h3>
          <h3 style={{ marginTop: '10px', marginBottom: '10px', color: 'red' }}> ※ ダウンロードの準備が正常に完了すると、下記リストの「ダウンロード」ボタンより画面用構成ファイルがダウンロードできます。</h3>
          <Col sm={12}>
            <Button
              variant="primary"
              className="btn-96"
              onClick={
                this.onClickDownLoad.bind(this, MessageTemplate.BULK_DOWNLOAD, null)
              }
            >
            ダウンロード開始
            </Button>
          </Col>
          <DownloadConfigFileList
            userfrontDownloadResultList={userfrontDownloadResultList}
            recordNum={recordNum}
            handleSortState={this.handleSortState}
            invalid={invalid}
            refreshData={this.refreshData}
            getStartEndData={this.getStartEndData}
            onClickDownloadFile={this.onClickDownloadFile}
            startPosition={startPosition}
          />
        </Form>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDownLoadCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDownloadOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { configFile } = state;
  const { downloadConfigFile } = configFile;
  const invalid = isInvalid('downloadConfigFile')(state);
  return {
    downloadConfigFile,
    invalid,
    formValues: getFormValues('downloadConfigFile')(state),
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'downloadConfigFile', // a unique identifier for this form
  touchOnChange: true,
  touchOnBlur: true,
})(DownloadConfigFileContainer));
